import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from '@mui/material';

import ImportExportIcon from '@mui/icons-material/ImportExport';
import ExcelPlayersImport from './excelPlayersImport';

const ImportPlayerDialog = () => {
  const event = useSelector((state) => state.event.event);

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="Import Players">
        <IconButton color="lightIcon" onClick={() => setOpen(true)}>
          <ImportExportIcon />
        </IconButton>
      </Tooltip>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Import Players</DialogTitle>
        <DialogContent>
          <ExcelPlayersImport eventId={event?.id} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ImportPlayerDialog;
